export class NavbarToggle {
  constructor(navbarId, toggleButtonId) {
    this.navbar = document.getElementById(navbarId);
    this.toggleButton = document.getElementById(toggleButtonId);
    this.navbarStateKey = 'navbarIsCollapsed';

    // Применить начальное состояние навигационной панели
    this.applyInitialNavbarState();

    // Назначение обработчика событий
    this.toggleButton.addEventListener('click', () => this.toggleNavbar());
  }

  applyInitialNavbarState() {
    // Проверка состояния в localStorage и применение класса
    const isCollapsed = localStorage.getItem(this.navbarStateKey) === 'true';
    if (isCollapsed) {
      this.navbar.classList.add('w-sm-0');
    } else {
      this.navbar.classList.remove('w-sm-0');
    }
    // Обновить иконку стрелки
    this.updateArrowDirection(isCollapsed);
  }

  toggleNavbar() {
    // Переключение класса
    this.navbar.classList.toggle('w-sm-0');
    const isCollapsed = this.navbar.classList.contains('w-sm-0');
    // Сохранение состояния в localStorage
    localStorage.setItem(this.navbarStateKey, isCollapsed);
    // Обновление иконки стрелки
    this.updateArrowDirection(isCollapsed);
  }

  updateArrowDirection(isCollapsed) {
    this.toggleButton.querySelector('i').style.transform = isCollapsed ? 'rotate(180deg)' : '';
  }
}
